import type { ReactNode } from 'react';
import { useProviderConnection } from '@/hooks/useProviderConnection';
import { SyncConnectionContext } from '@/contexts/SyncConnectionContext';

/**
 * Provider Props
 */
export interface SyncConnectionProviderProps {
  children: ReactNode;
  userId: string;
}

/**
 * SyncConnectionProvider - Mounts global provider connection state
 *
 * IMPORTANT: Only mount when user is authenticated (userId available).
 * Mounted in AppContent component after AuthProvider.
 *
 * @param children - Child components that need access to connection state
 * @param userId - Current authenticated user ID
 */
export function SyncConnectionProvider({
  children,
  userId
}: SyncConnectionProviderProps) {
  const value = useProviderConnection({ userId });

  return (
    <SyncConnectionContext.Provider value={value}>
      {children}
    </SyncConnectionContext.Provider>
  );
}
